export default function getBasename() {
  return window.KOCA_BASENAME || '';
}
